export const currencySymbol = (type) => {
    const symbol = {
        "INR": "₹"
    }
    return symbol[type] ? symbol[type] : "₹"
}